import { TOKEN, REFRESH_TOKEN, SPYEE_TOKEN, SPYEE_REFRESH_TOKEN } from 'constants/index';

export function getAccessToken(): string | null {
    return window.TOTEM?.storage?.get?.(TOKEN) || null;
}

export function getRefreshToken(): string | null {
    return window.TOTEM?.storage?.get?.(REFRESH_TOKEN) || null;
}

export function setTokens(accessToken: string, refreshToken: string): void {
    window.TOTEM.storage.set(TOKEN, accessToken);
    window.TOTEM.storage.set(REFRESH_TOKEN, refreshToken);
}

export function clearTokens(): void {
    window.TOTEM.storage.remove(TOKEN);
    window.TOTEM.storage.remove(REFRESH_TOKEN);
    window.TOTEM.storage.remove(SPYEE_TOKEN);
    window.TOTEM.storage.remove(SPYEE_REFRESH_TOKEN);
}

export function hasAccessToken(): boolean {
    return !!window.TOTEM?.storage?.get?.(TOKEN);
}

export function hasRefreshToken(): boolean {
    return !!window.TOTEM?.storage?.get?.(REFRESH_TOKEN);
}
